import { render, staticRenderFns } from "./videoDemo.vue?vue&type=template&id=2cc8f096&scoped=true"
import script from "./videoDemo.vue?vue&type=script&lang=js"
export * from "./videoDemo.vue?vue&type=script&lang=js"
import style0 from "./videoDemo.vue?vue&type=style&index=0&id=2cc8f096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8f096",
  null
  
)

export default component.exports